module.exports = __webpack_public_path__ + "static/media/bulmers.0675f466.png";